(ns shared.core.components.separator
  (:require [shared.core.style :as style]))

(defn separator [{:keys [color width style]
                  :or {color (style/color :gray :shade-7)
                       width "100%"}}]
  [:div {:style (merge {:background-color color
                        :height 1
                        :width width}
                       style)}])

(defn or-separator [{:keys [color style or-style]
                     :or {color (style/color :gray :base)}}]
  [:div {:style (merge {:display :flex
                        :align-items :center}
                       style)}
   [:div {:style {:background-color color
                  :flex 1
                  :height 1}}]
   [:div {:style (merge {:color color
                         :font-size 12
                         :letter-spacing "1px"
                         :text-transform :uppercase
                         :flex "0 0 auto"
                         :margin "0 10px"}
                        or-style)}
    "OR"]
   [:div {:style {:background-color color
                  :flex 1
                  :height 1}}]])

(defn spacer [{:keys [style]}]
  [:div {:style (merge {:flex 1} style)}])
